<!-- NOTE: This is not confirmation dialog, but the size fits for confirmation
type. Maybe should be consider renaming 'confirmation' sizing type so that we
are not limited for the usage -->
<atn-ds-centered-overlay
  type="confirmation"
  (backdropClick)="backdropClick.emit()"
>
  <div class="add-label-overlay">
    <div class="add-label-overlay__header">
      <h6>{{ name }}</h6>
      <div
        class="add-label-overlay__header-close-btn"
        (click)="close.emit()"
      >
        <i class="atn-icon atn-close atn-red"></i>
      </div>
    </div>
    <div class="add-label-overlay__body">
      <atn-ds-text
        [value]="value"
        (change)="labelChange.emit($event)"
      />
    </div>
    <div class="add-label-overlay__footer">
      <atn-ds-button
        class="add-label-overlay__footer-cancel-btn"
        (click)="cancel.emit()"
        type="transparent"
        >Cancel</atn-ds-button
      >
      <atn-ds-button
        type="primary"
        (click)="add.emit()"
        >Save</atn-ds-button
      >
    </div>
  </div>
</atn-ds-centered-overlay>
